import * as React from 'react';
import debounce from 'lodash/debounce';
import { InView } from 'react-intersection-observer';
import { TextLabel, Button } from '@wix/wix-base-ui';

import openExternalUrl from '../../utils/openExternalUrl';
import { BI_EVENTS, UPDATES_PAGE_LINK } from '../../constants';

import { WithSendBi } from '../../types';

import styles from './FeedFooter.scss';

interface FeedFooterProps extends WithSendBi {
  footerTitle: string;
  footerLink: string;
}

const ON_VIEWED_TIME = 1000;

class FeedFooter extends React.Component<FeedFooterProps> {
  static displayName = 'FeedFooter';

  isViewed: boolean = false;

  onViewed = debounce((inView: boolean) => {
    if (!inView || this.isViewed) {
      return;
    }

    this.isViewed = true;
    this.props.sendBI(BI_EVENTS.FOOTER_VIEWED);
  }, ON_VIEWED_TIME);

  onButtonClick = () => {
    openExternalUrl(UPDATES_PAGE_LINK);

    this.props.sendBI(BI_EVENTS.CARD_VIEWED);
  };

  render() {
    const { footerTitle, footerLink } = this.props;

    return (
      <InView threshold={0.75} onChange={this.onViewed}>
        <div className={styles.footer}>
          <TextLabel type="T21" value={footerTitle} className={styles.title} shouldTranslate={false} />
          <Button
            className="btn-md btn-confirm-secondary"
            onClick={this.onButtonClick}
          >
            <TextLabel type="T07" value={footerLink} shouldTranslate={false} />
          </Button>
        </div>
      </InView>
    );
  }
}

export default FeedFooter;
